<template>
  <b-tabs>
    <b-tab
      :title="$t('employeeCompany')"
      :active="activeTab == 1"
      @click="activeTab = 1"
    >
      <b-card-text>
        <vue-good-table
          class="mt-1"
          :columns="fields.employeeCompany.column"
          :rows="fields.employeeCompany.items"
          :line-numbers="true"
          :search-options="{
            enabled: true,
            externalQuery: searchTerm,
          }"
          :pagination-options="{
            enabled: true,
            perPage: perPage,
          }"
        >
          <!-- pagination -->
          <template slot="pagination-bottom" slot-scope="props">
            <div class="d-flex justify-content-between flex-wrap">
              <div class="d-flex align-items-center mb-0 mt-1">
                <span class="text-nowrap"> {{ $t("showing") }}</span>
                <b-form-select
                  v-model="perPage"
                  :options="['10', '50', '100']"
                  class="mx-1"
                  @input="
                    (value) => props.perPageChanged({ currentPerPage: value })
                  "
                />
                <span class="text-nowrap">
                  {{ $t("entries") }}
                </span>
              </div>
              <div>
                <b-pagination
                  :value="1"
                  :total-rows="totalItem"
                  :per-page="perPage"
                  first-number
                  last-number
                  align="right"
                  prev-class="prev-item"
                  next-class="next-item"
                  class="mt-1 mb-0"
                  @input="(value) => props.pageChanged({ currentPage: value })"
                >
                  <template #prev-text>
                    <feather-icon icon="ChevronLeftIcon" size="18" />
                  </template>
                  <template #next-text>
                    <feather-icon icon="ChevronRightIcon" size="18" />
                  </template>
                </b-pagination>
              </div>
            </div>
          </template>
        </vue-good-table>
      </b-card-text>
    </b-tab>
    <b-tab :title="$t('employee')" :active="activeTab == 2" @click="activeTab = 2">
      <b-card-text>
        <vue-good-table
          :columns="fields.employeeCompany.column"
          :rows="fields.employeeCompany.items"
          :line-numbers="true"
        >
        </vue-good-table>
      </b-card-text>
    </b-tab>
    <b-tab :title="$t('Location')" :active="activeTab == 3" @click="activeTab = 3">
      <vue-good-table
        class="mt-1"
        :columns="fields.location.column"
        :rows="fields.location.items"
        :line-numbers="true"
      >
      </vue-good-table>
    </b-tab>
    <b-tab
      :title="$t('quotationApproved')"
      :active="activeTab == 4"
      @click="activeTab = 4"
    >
      <b-card-text>
        <vue-good-table
          :columns="fields.quotationApproved.column"
          :rows="fields.quotationApproved.items"
          :line-numbers="true"
        >
        </vue-good-table>
      </b-card-text>
    </b-tab>
    <b-tab
      :title="$t('bookings') " 
      :active="activeTab == 5"
      @click="activeTab = 5"
    >
      <b-card-text>
        <vue-good-table
          :columns="fields.booking.column"
          :rows="fields.booking.items"
          :line-numbers="true"
          :search-options="{
            enabled: true,
            externalQuery: searchTerm,
          }"
          :pagination-options="{
            enabled: true,
            perPage: perPage,
          }"
        >
          <template slot="table-row" slot-scope="props">
            <!-- Column: Action -->

            <span v-if="props.column.field === 'status'">
              <span>
                {{
                  props.row.status == "Paid" ? "Completed" : props.row.status
                }}
              </span>
            </span>
            <!-- Column: Common -->
            <span v-else>
              {{ props.formattedRow[props.column.field] }}
            </span>
          </template>
          <!-- pagination -->
          <template slot="pagination-bottom" slot-scope="props">
            <div class="d-flex justify-content-between flex-wrap">
              <div class="d-flex align-items-center mb-0 mt-1">
                <span class="text-nowrap"> {{ $t("showing") }}</span>
                <b-form-select
                  v-model="perPage"
                  :options="['10', '50', '100']"
                  class="mx-1"
                  @input="
                    (value) => props.perPageChanged({ currentPerPage: value })
                  "
                />
                <span class="text-nowrap">
                  {{ $t("entries") }}
                </span>
              </div>
              <div>
                <b-pagination
                  :value="1"
                  :total-rows="totalItem"
                  :per-page="perPage"
                  first-number
                  last-number
                  align="right"
                  prev-class="prev-item"
                  next-class="next-item"
                  class="mt-1 mb-0"
                  @input="(value) => props.pageChanged({ currentPage: value })"
                >
                  <template #prev-text>
                    <feather-icon icon="ChevronLeftIcon" size="18" />
                  </template>
                  <template #next-text>
                    <feather-icon icon="ChevronRightIcon" size="18" />
                  </template>
                </b-pagination>
              </div>
            </div>
          </template>
        </vue-good-table>
      </b-card-text>
    </b-tab>
    <b-tab  :title="$t('unPaid') " :active="activeTab == 6" @click="activeTab = 6">
      <b-card-text>
        <vue-good-table
          :columns="fields.booking.column"
          :rows="fields.booking.items"
          :line-numbers="true"
          :search-options="{
            enabled: true,
            externalQuery: searchTerm,
          }"
          :pagination-options="{
            enabled: true,
            perPage: perPage,
          }"
        >
          <template slot="table-row" slot-scope="props">
            <!-- Column: Action -->

            <span v-if="props.column.field === 'status'">
              <span> {{$t('unPaid')}} </span>
            </span>
            <!-- Column: Common -->
            <span v-else>
              {{ props.formattedRow[props.column.field] }}
            </span>
          </template>
          <!-- pagination -->
          <template slot="pagination-bottom" slot-scope="props">
            <div class="d-flex justify-content-between flex-wrap">
              <div class="d-flex align-items-center mb-0 mt-1">
                <span class="text-nowrap"> {{ $t("showing") }}</span>
                <b-form-select
                  v-model="perPage"
                  :options="['10', '50', '100']"
                  class="mx-1"
                  @input="
                    (value) => props.perPageChanged({ currentPerPage: value })
                  "
                />
                <span class="text-nowrap">
                  {{ $t("entries") }}
                </span>
              </div>
              <div>
                <b-pagination
                  :value="1"
                  :total-rows="totalItem"
                  :per-page="perPage"
                  first-number
                  last-number
                  align="right"
                  prev-class="prev-item"
                  next-class="next-item"
                  class="mt-1 mb-0"
                  @input="(value) => props.pageChanged({ currentPage: value })"
                >
                  <template #prev-text>
                    <feather-icon icon="ChevronLeftIcon" size="18" />
                  </template>
                  <template #next-text>
                    <feather-icon icon="ChevronRightIcon" size="18" />
                  </template>
                </b-pagination>
              </div>
            </div>
          </template>
        </vue-good-table>
      </b-card-text>
    </b-tab>
  </b-tabs>
</template>



<script>
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required } from "@validations";
import vSelect from "vue-select";
import Select2 from "v-select2-component";
import {
  ref,
  reactive,
  watch,
  computed,
  onUnmounted,
} from "@vue/composition-api";

import FeatherIcon from "@/@core/components/feather-icon/FeatherIcon.vue";
import { VueGoodTable } from "vue-good-table";
import "@core/scss/vue/libs/vue-good-table.scss";
import companyManagerStoreModule from "./companyManagerStoreModule";
import { useUtils as useI18nUtils } from "@core/libs/i18n";
import store from "@/store";

export default {
  components: {
    vSelect,
    FeatherIcon,
    ValidationProvider,
    ValidationObserver,
    Select2,
    TabModalCompanyDetai: () => import("./TabModalCompanyDetai"),
    VueGoodTable,
  },
  props: {
    taxCode: { default: "" },
  },
  setup(props, ctx) {
    const { t } = useI18nUtils();
    const items = ref([]);
    const activeTab = ref(1);
    const taxCode = props.taxCode || "";
    const fields = reactive({
      employeeCompany: {
        items: [],
        column: [
          {
            label: t("userName"),
            field: "code",
            filterOptions: { enabled: true, placeholder: "UserName" },
            required: true,
            sortable: false,
          },
          {
            field: "name",
            label: t("name"),
            filterOptions: { enabled: true, placeholder: t("name") },
            required: true,
            sortable: false,
          },
          {
            field: "mobile",
            label: t("phone"),
            filterOptions: { enabled: true, placeholder: t("phone") },
            required: true,
            sortable: false,
          },
        ],
      },
      employeeWR1: {
        items: [],
        column: [
          {
            label: t("taxCode"),
            field: "tax_code",
            type: "number",
            filterOptions: { enabled: true, placeholder: "ID" },
            disabled: true,
            autoIncrement: true,
          },
          {
            field: "name",
            label: t("name"),
            filterOptions: { enabled: true, placeholder: "Name" },
            required: true,
            sortable: false,
          },
          {
            field: "address",
            label: t("address"),
            filterOptions: { enabled: true, placeholder: "Name" },
            required: true,
            sortable: false,
          },
          {
            field: "action",
            label: t("actions"),
            width: "100px",
            tdClass: "text-center",
            sortable: false,
          },
        ],
      },
      location: {
        items: [],
        column: [
          {
            label: t("Location"),
            field: "location",
            filterOptions: { enabled: true, placeholder: "location" },
            disabled: true,
            autoIncrement: true,
          },
          {
            field: "created_by",
            label: t("createdBy"),
            filterOptions: { enabled: true, placeholder: t("createdBy") },
            required: true,
            sortable: false,
          },
          {
            field: "longitude",
            label: t("longitude"),
            filterOptions: { enabled: true, placeholder: t("longitude") },
            required: true,
            sortable: false,
          },
          {
            field: "longitude",
            label: t("latitude"),
            filterOptions: { enabled: true, placeholder: t("latitude") },
            required: true,
            sortable: false,
          },
        ],
      },
      quotationApproved: {
        items: [],
        column: [
          {
            label: "ID",
            field: "id",
            filterOptions: { enabled: true, placeholder: "id" },
            disabled: true,
            autoIncrement: true,
          },
          {
            label: t("service"),
            field: "service_type",
            filterOptions: { enabled: true, placeholder: t("service") },
            required: true,
            sortable: false,
          },
          {
            label: "POL",
            field: "pol",
            filterOptions: { enabled: true, placeholder: "AOL" },
            required: true,
            sortable: false,
          },
          {
            label: "POD",
            field: "pod",
            filterOptions: { enabled: true, placeholder: "POD" },
            required: true,
            sortable: false,
          },
          {
            label: "ETD",
            field: "from_date",
            filterOptions: {
              enabled: true,
              placeholder: "ETD",
            },
          },
          {
            label: "ETA",
            field: "to_date",
            filterOptions: {
              enabled: true,
              placeholder: "ETA",
            },
          },
          {
            label: t("date"),
            field: "date_",
            filterOptions: {
              enabled: true,
              placeholder:  t("date"),
            },
          },
          {
            label: t("expDate"),
            field: "valid_to",
            filterOptions: {
              enabled: true,
              placeholder:  t("expDate"),
            },
          },
        ],
      },
      booking: {
        items: [],
        column: [
          {
            label: "Booking ID",
            field: "id",
            filterOptions: {
              enabled: true,
              placeholder: "Booking ID",
            },
          },
          {
             label: t("status"),
            field: "status",
            filterOptions: {
              enabled: true,
            },
          },
          {
            label: t("service"),
            field: "service_type",
            filterOptions: {
              enabled: true,
              placeholder: "Service Type",
            },
          },
          {
            label: "POL",
            field: "pol",
            filterOptions: {
              enabled: true,
            },
          },
          {
            label: "POD",
            field: "pod",
            filterOptions: {
              enabled: true,
            },
          },
          {
            label: "ETD",
            field: "from_date",
            filterOptions: {
              enabled: true,
              placeholder: "ETD",
            },
          },
          {
            label: "ETA",
            field: "to_date",
            filterOptions: {
              enabled: true,
              placeholder: "ETA",
            },
          },
          {
            label: t("shipper"),
            field: "shipper",
            filterOptions: {
              enabled: true,
            },
          },
          {
            label: "CNEE",
            field: "cnee",
            filterOptions: {
              enabled: true,
            },
          },
        ],
      },
    });

    const totalItem = ref(0);
    const permisItems = ref([]);
    const perPage = ref(10);
    const searchQuery = ref("");
    const searchTerm = ref("");
    const CHAT_APP_STORE_MODULE_NAME = "company-manager";

    // Register module
    if (!store.hasModule(CHAT_APP_STORE_MODULE_NAME))
      store.registerModule(
        CHAT_APP_STORE_MODULE_NAME,
        companyManagerStoreModule
      );

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(CHAT_APP_STORE_MODULE_NAME))
        store.unregisterModule(CHAT_APP_STORE_MODULE_NAME);
    });

    const fetchCompanyAll = () => {
      store.dispatch("company-manager/fetchCompanyAll").then((response) => {
        items.value = response.data.result;
        totalItem.value = response.data.meta.total;
      });
    };

  

    fetchCompanyAll();

    watch(activeTab, (selection, prevSelection) => {
      switch (selection) {
        case 1:
          fetchCustomerListCompanyAll();
          break;
  case 2:
          fetchSaleListCompany();
          break;
        case 3:
          fetchLocationsAll();
          break;
        case 4:
          fetchQuotationApprovedAll();
          break;
        case 5:
          fetchBookingAll();
          break;
        case 6:
          fetchUnPaidAll();
          break;
        default:
          break;
      }
    });

    const fetchQuotationApprovedAll = () => {
      store
        .dispatch("company-manager/fetchQuotationApprovedAll", {
          search: { status: "3,4,21",taxCode:taxCode },
        })
        .then((response) => {
          fields.quotationApproved.items = response.data.result;
          totalItem.value = response.data.meta.total;
        });
    };

    


     const fetchSaleListCompany = () => {
      store
        .dispatch("company-manager/fetchSaleListCompany", {
          search: taxCode,
        })
        .then((response) => {
          fields.employeeCompany.items = response.data.result;
          totalItem.value = response.data.meta.total;
        });
    };
    const fetchCustomerListCompanyAll = () => {
      store
        .dispatch("company-manager/fetchCustomerListCompanyAll", {
          search: taxCode,
        })
        .then((response) => {
          fields.employeeCompany.items = response.data.result;
          totalItem.value = response.data.meta.total;
        });
    };
    const fetchLocationsAll = () => {
      store
        .dispatch("company-manager/fetchLocationsAll", {
          taxCode: `${taxCode}`,
          pageSize: 999999,
          page: 1,
        })
        .then((response) => {
          fields.location.items = response.data.result;
          totalItem.value = response.data.meta.total;
        });
    };

    const fetchBookingAll = () => {
      store
        .dispatch("company-manager/fetchBookingAll", {
          search: { status: "5,6,61,62,63,7,8,9,10,11",taxCode:taxCode },
        })
        .then((response) => {
          fields.booking.items = response.data.result;
          totalItem.value = response.data.meta.total;
        });
    };

    const fetchUnPaidAll = () => {
      store
        .dispatch("company-manager/fetchBookingAll", {
          search: { status: "10",taxCode:taxCode },
        })
        .then((response) => {
          fields.booking.items = response.data.result;
          totalItem.value = response.data.meta.total;
        });
    };
    fetchCustomerListCompanyAll();
    return {
      // value
      items,
      fields,
      totalItem,
      permisItems,
      perPage,
      searchQuery,
      searchTerm,
      activeTab,
      // action

      // onSearch,
    };
  },
};
</script>

